'use client';

import { Suspense, type ReactElement } from 'react';
import { Await } from 'react-router';
import type { BrandContent } from '@/lib/api/fetch-brand';
import Brand, { type BrandProps } from '@/components/brand';
import { BrandSkeleton } from '@/components/brand/brand-skeleton';

type DeferredProps = {
    contentPromise: Promise<BrandContent | null>;
} & Omit<BrandProps, 'data'>;

/** Resolves deferred Brand custom-object data from the category loader behind Suspense. */
export function BrandDeferred({ contentPromise, className, ...brandProps }: DeferredProps): ReactElement {
    return (
        <Suspense fallback={<BrandSkeleton className={className} />}>
            <Await resolve={contentPromise}>
                {(data) => <Brand data={data} className={className} {...brandProps} />}
            </Await>
        </Suspense>
    );
}
